<template>
  <div class="page">
    <div class="group_1">
      <div class="text_1">可将多个学时合并为一个，先选择需要合并的课程，再点击”学时合并“按钮即可完成操作</div>
      <div class="group_2">
        <!-- 表头 -->
        <van-cell class="table-header" :border="false">
          <div class="col-check">
            <van-checkbox v-model="selectAll" @change="handleSelectAll">全选</van-checkbox>
          </div>
          <div class="col-course1">课程名称</div>
          <div class="col-hours1">完成学时</div>
        </van-cell>

        <!-- 课程列表 -->
        <div v-if="courses.length > 0">
          <!-- <van-cell-group> -->
          <van-cell v-for="(course, index) in courses" :key="index" :border="index < courses.length - 1">
            <div class="table-row-content">
              <div class="col-check">
                <van-checkbox v-model="course.checked" @change="handleCourseCheck"></van-checkbox>
              </div>
              <div class="col-course">{{ course.courseName }}</div>
              <div class="col-hours">{{ course.credit }}</div>
            </div>
          </van-cell>
        </div>
        <div v-else style="margin-top: 20px; text-align: center">暂无数据</div>
        <!-- </van-cell-group> -->
      </div>
      <!-- 底部按钮 -->
      <div class="button-container">
        <van-button class="default" @click="handleXs">已合并学时</van-button>
        <van-button class="danger" @click="handleHb">学时合并</van-button>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getCreditApplyList, mergeCredit } from '../../api/certificate';
import { Dialog } from 'vant';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      selectAll: false,
      courses: [],
      classId: '',
      creditSum: 0,
      creditIds: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 去已合并学时
    handleXs() {
      this.$router.push({
        path: '/combined',
        query: { classId: this.$route.query.classId }
      });
    },
    // 处理全选
    handleSelectAll() {
      this.courses.forEach(course => {
        course.checked = this.selectAll;
      });
      this.updateCreditSumAndIds();
    },
    getList() {
      getCreditApplyList({ classId: this.$route.query.classId }).then(res => {
        this.courses = res.data.data.map(item => ({
          ...item,
          checked: false
        }));
      });
    },
    handleCourseCheck() {
      this.updateCreditSumAndIds();
    },
    updateCreditSumAndIds() {
      let sum = 0;
      let ids = [];
      this.courses.forEach(course => {
        if (course.checked) {
          sum += course.credit;
          ids.push(course.creditId);
        }
      });
      this.creditSum = sum;
      this.creditIds = ids.join(',');
    },
    //合并学时
    handleHb() {
      console.log(this.creditSum,this.creditIds,'333');
      
      if (!this.creditIds) {
        Dialog.alert({
          title: '温馨提示',
          message: '请先选择要合并的学时'
        });
        return;
      }
      Dialog.confirm({
        title: '温馨提示',
        message: '确定合并该学时吗？'
      }).then(() => {
        mergeCredit({ classId: this.classId, creditSum: this.creditSum, creditIds: this.creditIds }).then(res => {
          if (res.data.code == 200) {
            this.$toast.success('学时合并成功');
            this.getList();
          } else {
            this.$toast.fail('学时合并失败');
          }
        });
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
    this.classId = this.$route.query.classId;
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.group_1 {
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.text_1 {
  width: 100%;
  height: 60px;
  background: rgba(255, 100, 100, 0.08);
  border-radius: 8px 8px 8px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ff6464;
  padding: 12px 15px;
}
.group_2 {
  width: 100%;
  margin-top: 15px;
  background-color: #ffffff;
  border-radius: 8px !important;
  padding-bottom: 10px;
  .van-cell {
    // border-radius: 8px !important;
  }
  .van-cell__value {
    display: flex;

    justify-content: space-between;
    // border-bottom: 1px solid #e8e8e8;
  }

  .table-header {
    border-radius: 8px 8px 0 0 !important;

    border-bottom: 1px solid #ebedf0;
    display: flex;
    align-items: center;
    padding: 12px 15px;
    .col-check {
      width: 82px;
      display: flex;
      align-items: center;
    }

    .col-course {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: center;
      width: 148px;
    }

    .col-hours {
      width: 103px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: right;
    }
    .col-course1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #333333;
      text-align: center;
    }

    .col-hours1 {
      width: 103px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #333333;
      text-align: right;
    }
  }

  .table-row-content {
    display: flex;
    align-items: center;
    width: 100%;
justify-content: space-between;
    .col-check {
      width: 82px;
      display: flex;
      align-items: center;
    }

    .col-course {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: center;
      width: 148px;
    }

    .col-hours {
      width: 103px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: right;
    }
  }
}
.default {
  width: 165px;
  height: 46px;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #ff6464;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #ff6464;
  // margin-right: 15px;//
}
.danger {
  width: 165px;
  height: 46px;
  background: #ff6464;
  border-radius: 10px 10px 10px 10px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
}
.button-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
/deep/.van-checkbox__icon--round .van-icon {
  border-radius: 23% !important;
}
/deep/ .van-cell-group {
  border-bottom: 0 !important;
}
</style>
